module.exports = __webpack_public_path__ + "img/yellow-gem.3b6d250f.svg";